/**
 * @see https://sail.stripe.me/apis/intl/message
 */ export default function message(/** The [message descriptor](/apis/intl/localized-messages#message-descriptor). */ descriptor) {
    return descriptor;
}

//# sourceMappingURL=message.js.map